export const projectsList = {
  label: 'Nombre del Proyecto',
  price: 'Precio del Proyecto: 3.400 €',
  execution: 'Ejecución del Presupuesto: 324.166 €',
};
